import { usePendingOrgBillingTransfer } from "@components/billing/OrgBillingTransfer/usePendingOrgBillingTransfer";
import { workspaceOwnsBilling } from "@helpers/billingOwnership";
import { useActiveWorkspaceDetails } from "@hooks/useActiveWorkspaceDetails";
import { useCanRequestBillingTransfer } from "./useCanRequestBillingTransfer";

export function useCanViewBillingTransfer() {
    const canRequestBillingTransfer = useCanRequestBillingTransfer();
    const pendingOrgBillingTransfer = usePendingOrgBillingTransfer();
    const activeWorkspaceDetails = useActiveWorkspaceDetails();

    const isOrgBillingTransferRecipient =
        !!pendingOrgBillingTransfer &&
        !!activeWorkspaceDetails &&
        !workspaceOwnsBilling(activeWorkspaceDetails);

    return canRequestBillingTransfer || isOrgBillingTransferRecipient;
}
